import ContentBlock from '@/components/ContentBlock';
import ContentColumnsBlock from '@/components/ContentColumnsBlock';
import ContentMediaList from '@/components/ContentVideoBlock';
import KiaHeroSlider from '@/components/kie-ev5-campaign/carousel';
import GreyListbox from '@/components/newKiaEV6/GreyListBox';
import InfoBoxImgTextLinks from '@/components/newKiaEV6/InfoBoxImgTextLinks';
import AnimatedSection from '@/components/privatleasing/AnimatedSection';
import { TextBox } from '@/components/privatleasing/TextBox';
import VideoHero from '@/components/rentAndShare/video-hero';
import KIAImage from '@/components/ui/image/KIAImage';
import LinkButton from '@/components/ui/LinkButton';
import { m } from 'motion/react';
import { itemVariants } from '../../../utils/framer';
import {
  CarouselEV5,
  contentBlocksEV5,
  featuresEV5,
  greyListEV5,
  hero2EV5,
  heroEV5,
  infoBoxEV5,
  infoColumns2EV5,
  infoColumnsEV5,
  introEV5,
  textBoxicon01,
} from './kiaEv5campaignTypes';

const KiaEv5Campaign = () => {
  return (
    <main className="relative w-full">
      <VideoHero {...heroEV5} className="h-[85svh]" />
      <AnimatedSection id="ev-5-heading" className="wrapper-kia-sm my-14">
        <m.h2
          variants={itemVariants}
          className="mb-2 text-center font-bold text-[32px] md:text-[40px] leading-[1.2]"
        >
          {introEV5.heading}
        </m.h2>
        <m.p variants={itemVariants} className="text-center font-semibold">
          {introEV5.headingSub}
        </m.p>
        <m.p variants={itemVariants} className="mt-8 text-center">
          {introEV5.text}
        </m.p>
      </AnimatedSection>
      <AnimatedSection id="ev5-intro" className="wrapper-kia-sm">
        <m.div variants={itemVariants}>
          <KIAImage
            {...introEV5.image}
            className={`${introEV5.image.className || ''}`}
          />
        </m.div>

        <TextBox
          iconOnTop
          centerText
          mtClass="mt-8"
          paddingClass="p-0"
          {...textBoxicon01}
        />

        <m.div variants={itemVariants} className="flex justify-center my-14">
          <LinkButton url={introEV5.link.url} text={introEV5.link.text} />
        </m.div>
      </AnimatedSection>

      <VideoHero src={hero2EV5.src} controls className="aspect-video" />

      <AnimatedSection
        id="ev5-features"
        className="wrapper-kia-md mx-auto my-10 lg:my-24"
      >
        <ContentMediaList items={featuresEV5} />
      </AnimatedSection>

      <AnimatedSection
        id="ev5-content-blockss"
        className="wrapper-kia-md mx-auto my-10 lg:my-24"
      >
        <ContentBlock blocks={contentBlocksEV5} firstBlockReversed />
      </AnimatedSection>

      <AnimatedSection id="ev5-hero-image" className="my-10 lg:my-24">
        <KiaHeroSlider slides={CarouselEV5} />
      </AnimatedSection>

      <AnimatedSection
        id="ev5-infobox"
        className="wrapper-kia-md mx-auto my-14 lg:my-24"
      >
        <m.div variants={itemVariants}>
          <InfoBoxImgTextLinks titleFontSize="text-4xl" {...infoBoxEV5} />
        </m.div>
      </AnimatedSection>

      <AnimatedSection
        id="ev5-infocolumns"
        className="wrapper-kia-lg mx-auto my-14 lg:my-24"
      >
        <ContentColumnsBlock columns={infoColumnsEV5} />
      </AnimatedSection>

      <AnimatedSection
        id="ev5-greylist"
        className="wrapper-kia-md mx-auto my-10 lg:my-24"
      >
        <GreyListbox
          className="[&_div:has(svg)]:self-center"
          {...greyListEV5}
        />
      </AnimatedSection>

      <AnimatedSection
        id="ev5-infocolumns2"
        className="wrapper-kia-lg mx-auto my-14 lg:my-24"
      >
        <ContentColumnsBlock columns={infoColumns2EV5} />
      </AnimatedSection>
    </main>
  );
};

export default KiaEv5Campaign;
